import { Link } from '@modern-js/runtime/router';

export default () => (
  <>
    <Link to="/bsc">Go BSC Test Page</Link>
    <br />
    <Link to="/bbc">Go BBC Test Page</Link>
    <br />
    <Link to="/eth">Go ETH Test Page</Link>
  </>
);
